import React, { createContext, useContext, useState } from "react";

const AdminThemeContext = createContext({ isDark: true, toggleTheme: () => {} });

export function AdminThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    try { return localStorage.getItem("admin-theme") !== "light"; }
    catch { return true; }
  });

  const toggleTheme = () => {
    setIsDark(prev => {
      const next = !prev;
      try { localStorage.setItem("admin-theme", next ? "dark" : "light"); } catch {}
      return next;
    });
  };

  return (
    <AdminThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </AdminThemeContext.Provider>
  );
}

export function useAdminTheme() {
  return useContext(AdminThemeContext);
}
